<script setup lang="ts">
  import bannerContentImg from "~/assets/images/aigc/banner-content.png";
  import anqingfenxiImg from "~/assets/images/settlement/anqingfenxi.png";
  import anyuanguanchangImg from "~/assets/images/settlement/anyuanguanchang.png";
  import banner2Img from "~/assets/images/settlement/banner2.png";
  import falvguandianImg from "~/assets/images/settlement/falvguandian.png";
  import falvyanjiuImg from "~/assets/images/settlement/falvyanjiu.png";
  import shangnjituisongImg from "~/assets/images/settlement/shagnjituisong.png";
  import shuzimingpianImg from "~/assets/images/settlement/shuzimingpian.png";
  import wenbenshengchengImg from "~/assets/images/settlement/wenbenshengcheng.png";
  import xiaoliaiImg from "~/assets/images/settlement/xiaoliai.png";
  import xinfaImg from "~/assets/images/settlement/xinfa.png";
  import zhihuibangongImg from "~/assets/images/settlement/zhihuibangong.png";
  import zhinengtiImg from "~/assets/images/settlement/zhinengti.png";
  import SettlementRight from "~/components/settlement/SettlementRight.vue";
  import Logger from "~/utils/logger";

  definePageMeta({
    layout: "nav-layout",
  });

  interface CarouselProps {
    icon: string;
    activeIcon?: string;
    title: string;
    desc: string;
    image: string;
  }

  interface SettlementRightProps {
    title: string;
    desc: string;
    imagePlacement: "left" | "right";
    anchorID?: string;
    carousel: CarouselProps[];
  }

  const api = useApi();

  const router = useRouter();

  // 入驻权益
  const settlementRights = [
    {
      icon: "falvdamoxing",
      title: "免费体验法律AI大模型",
      desc: "平台为入驻律师提供最前沿的AI法律工具使用权，全方位赋能助力律师高效完成法律研究、案情分析、文书撰写等工作",
    },
    {
      icon: "anyuantuijian",
      title: "AI平台精准案源推荐",
      desc: "AI平台通过智能算法精准匹配案源，筛选高意向客户并提供高价值线索，确保入驻律师接触相关案件，提高业务拓展效率",
    },
    {
      icon: "kejizixun",
      title: "前沿法律科技资讯",
      desc: "入驻律师将持续获取最新的法律科技资讯和行业动态，精准掌握市场动向，确保在法律服务领域保持领先",
    },
    {
      icon: "shuzhihuafuwu",
      title: "数智化转型与服务升级",
      desc: "入驻律师将加速实现法律服务的数字化和智能化转型，利用平台技术优势简化工作流程，提高工作效率",
    },
  ];

  // 入驻权益列表
  const settlementList: SettlementRightProps[] = [
    {
      title: "免费体验法律AI大模型",
      desc: "平台为入驻律师提供最前沿的AI法律工具使用权，全方位赋能助力律师高效完成法律研究、案情分析、文书撰写等工作，极大提升工作效率",
      imagePlacement: "left",
      carousel: [
        {
          icon: "yanjiuzhulu1",
          title: "法律研究",
          desc: "自动化处理文档，加速法律研究",
          image: falvyanjiuImg,
        },
        {
          icon: "xiebofenxi1",
          title: "案情分析",
          desc: "结合案情提供专业分析，预测案件走向",
          image: anqingfenxiImg,
        },
        {
          icon: "wenben1",
          title: "文本生成",
          desc: "自动撰写法律文书和各类文书，提升效率",
          image: wenbenshengchengImg,
        },
      ],
    },
    {
      title: "AI平台精准案源推荐",
      desc: "AI平台通过智能算法精准匹配案源，筛选高意向客户并提供高价值线索，确保入驻律师接触相关案件，提高业务拓展效率",
      imagePlacement: "right",
      carousel: [
        {
          icon: "mingpian1",
          title: "数字名片",
          desc: "自定义AI加持，多维展示律师形象",
          image: shuzimingpianImg,
        },
        {
          icon: "ce-anyuanzhongxin1",
          title: "案源广场",
          desc: "智能匹配咨询需求，提升匹配精准度",
          image: anyuanguanchangImg,
        },
        {
          icon: "shangji1",
          title: "商机推送",
          desc: "实时更新市场资讯，洞察市场先机",
          image: shangnjituisongImg,
        },
      ],
    },
    {
      title: "前沿法律科技资讯",
      desc: "入驻律师将持续获取最新的法律科技资讯和行业动态，精准掌握市场动向，确保在法律服务领域保持领先",
      imagePlacement: "left",
      carousel: [
        {
          icon: "zhengcefagui1",
          title: "新法速递",
          desc: "快速了解最新法律法规",
          image: xinfaImg,
        },
        {
          icon: "pinglun1",
          title: "法律观点",
          desc: "分享法律人专属知识，构建知识社区",
          image: falvguandianImg,
        },
        {
          icon: "quanguowangluo1",
          title: "全国商机",
          desc: "实时收录各地商机，把握市场趋势",
          image: shangnjituisongImg,
        },
      ],
    },
    {
      title: "数智化转型与服务升级",
      desc: "入驻律师将加速实现法律服务的数字化和智能化转型，利用平台技术优势简化工作流程，提高工作效率，为客户提供更优质的服务体验",
      imagePlacement: "right",
      carousel: [
        {
          icon: "bangongfuwu1",
          title: "智慧办公",
          desc: "智能秘书辅助，提升工作管理效率",
          image: zhihuibangongImg,
        },
        {
          icon: "huiyuan-21",
          title: "专属智能体",
          desc: "个性化智能助手，助力律师数字化升级",
          image: zhinengtiImg,
        },
        {
          icon: "keji-21",
          title: "小理AI",
          desc: "前沿AI技术，构建智能法律服务的核心",
          image: xiaoliaiImg,
        },
      ],
    },
  ];

  // 特殊埋点
  const postSpecialTrack = () => {
    api.ai.specialTrack({ referer: window.location.href });
  };

  // 跳转入驻页面
  const toSettlement = () => {
    Logger.event("免费入驻_点击");
    router.push("/h5/dls/entry-form");
  };
  onMounted(() => {
    postSpecialTrack();
    Logger.event("律师入驻_浏览");
  });
</script>

<template>
  <div class="settlement">
    <div class="settlement-banner">
      <div class="settlement-banner-content">
        <!-- <p>诚邀全国优秀律师入驻</p>
        <p>国内<span>首个基于法律大模型</span></p>
        <p><span>"AI+律师"</span>服务平台</p> -->
        <img class="settlement-banner-image" :src="bannerContentImg" />
        <a-button @click="toSettlement">免费入驻</a-button>
      </div>
      <img :src="banner2Img" class="settlement-banner-lottie" />
    </div>
    <div class="settlement-rights-wrapper">
      <div class="settlement-rights">
        <div v-for="(right, idx) of settlementRights" :key="idx" class="settlement-right">
          <icon-font class="settlement-right-icon" :type="right.icon" />
          <!-- <Icon class="settlement-right-icon" :name="`custom:${right.icon}`" />-->
          <h3 class="settlement-right-title">{{ right.title }}</h3>
          <p class="settlement-right-desc ellipsis3">{{ right.desc }}</p>
        </div>
      </div>
    </div>

    <div
      v-for="(right, idx) of settlementList"
      :key="idx"
      class="settlement-rights-box"
      :class="`settlement-rights-box${idx}`">
      <SettlementRight v-bind="right" />
      <a-button v-if="idx === 3" @click="toSettlement">免费入驻</a-button>
    </div>
  </div>
</template>

<style scoped lang="less">
  .settlement {
    --title-text: 81px;
    --sub-title-text: 75px;
    --sub-title-mt: 61px;
    --sub-title-mb: 39px;
    --banner-btn-w: 462px;
    --banner-btn-h: 86px;
    --banner-btn-text: 42px;
    --banner-btn-leading: 49px;
    --lottie-display: block;
    --settlement-btn-m: 102px auto 175px;
    --settlement-btn-text: 42px;
    --settlement-btn-leading: 49px;
    --settlement-right1-pt: 192px;
    --lottie-top: 51px;

    min-width: 320px;
    overflow-x: auto;

    @media (max-width: 1536px) {
      --lottie-top: 71px;
    }

    @media (max-width: 1280px) {
      --lottie-top: 95px;
    }

    @media (max-width: 1024px) {
      --title-text: 66px;
      --sub-title-text: 60px;
      --sub-title-mt: 51px;
      --sub-title-mb: 29px;
      --lottie-display: none;
      --settlement-btn-m: 90px auto 160px;
      --settlement-btn-text: 30px;
      --settlement-btn-leading: 36px;
    }

    @media (max-width: 768px) {
      --settlement-right1-pt: 350px;
    }

    @media (max-width: 640px) {
      --title-text: 42px;
      --sub-title-text: 36px;
      --sub-title-mt: 41px;
      --sub-title-mb: 19px;
      --banner-btn-w: 300px;
      --banner-btn-h: 60px;
      --banner-btn-text: 24px;
      --banner-btn-leading: 24px;
      --settlement-btn-m: 80px auto 150px;
      --settlement-btn-text: 24px;
      --settlement-btn-leading: 30px;
    }

    @media (max-width: 480px) {
      --title-text: 30px;
      --sub-title-text: 24px;
      --sub-title-mt: 20px;
      --sub-title-mb: 9px;
      --settlement-btn-m: 60px auto 140px;
      --settlement-btn-text: 18px;
      --settlement-btn-leading: 24px;
    }

    .settlement-banner {
      position: relative;
      height: 988px;
      overflow: hidden;
      background-image: url("~/assets/images/settlement/banner.png");
      background-position: center;
      background-size: cover;

      .settlement-banner-content {
        position: absolute;
        top: 209px;
        left: 147px;
        z-index: 10;

        @media (max-width: 1024px) {
          left: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          transform: translateX(-50%);
        }

        p {
          margin-bottom: 0;
          font-size: var(--title-text);
          font-weight: bolder;
          line-height: var(--title-text);
          color: transparent;
          background-image: linear-gradient(90deg, #4285f4 42%, #004ee9 100%);
          background-clip: text;

          &:nth-of-type(2) {
            margin-top: var(--sub-title-mt);
            margin-bottom: var(--sub-title-mb);
            font-size: var(--sub-title-text);
            line-height: var(--sub-title-text);
          }

          &:nth-of-type(3) {
            margin-bottom: 117px;
            font-size: var(--sub-title-text);
            line-height: var(--sub-title-text);
          }

          span {
            background-image: linear-gradient(90deg, #ffc48d 0%, #ffae4f 56%, #f90 100%);
            background-clip: text;
          }
        }

        .settlement-banner-image {
          max-width: 46.22vw;
          height: auto;
          aspect-ratio: 887.47 / 357.97;
          margin-bottom: 117px;
          object-fit: cover;

          @media (max-width: 1024px) {
            width: calc(100% - 54px);
          }
        }

        .ant-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: var(--banner-btn-w);
          height: var(--banner-btn-h);
          font-size: var(--banner-btn-text);
          font-weight: bold;
          line-height: var(--banner-btn-leading);
          color: #7d4242;
          background: linear-gradient(90deg, #ffc063 0%, #ffedd4 50%, #ffc063 100%);
          border: none !important;
          border-radius: 98px;
          box-shadow:
            inset 0 2px 2px white,
            inset 0 -2px 2px rgba(91, 42, 31, 35%);
        }
      }

      .settlement-banner-lottie {
        position: absolute;
        top: var(--lottie-top);
        right: -183px;
        display: var(--lottie-display);
        width: 75vw;
        height: 59.06vw;
        overflow: hidden;
      }
    }

    .settlement-rights-wrapper {
      position: relative;

      .settlement-rights {
        position: absolute;
        top: 0;
        left: 50%;
        display: grid;
        grid-template-columns: repeat(4, minmax(376px, 1fr));
        width: 100%;
        max-width: 1836px;
        min-height: 186px;
        padding: 40px 44px;
        background: linear-gradient(#fff, #f2f5fa);
        border-radius: 16px;
        box-shadow: inset 0 3px 0 0 #fff;
        transform: translate(-50%, -50%);

        @media only screen and (max-width: 1536px) {
          grid-template-columns: repeat(2, minmax(376px, 1fr));
          gap: 16px 0;
          place-items: center center;
        }

        @media only screen and (max-width: 768px) {
          grid-template-columns: repeat(1, minmax(376px, 1fr));
          gap: 16px 0;
          place-items: center;
          padding: 16px;
        }

        .settlement-right {
          display: grid;
          grid-template-areas: "icon title" "icon desc";
          grid-auto-columns: 96px 256px;
          gap: 10px 20px;

          @media (max-width: 768px) {
            grid-auto-columns: 96px 1fr;
            width: calc(100% - 32px);
          }

          .settlement-right-icon {
            grid-area: icon;
            place-self: center;
            font-size: 96px;
          }

          .settlement-right-title {
            grid-area: title;
            font-size: 20px;
            font-weight: 600;
            line-height: 23px;
            color: #333;
          }

          .settlement-right-desc {
            grid-area: desc;
            margin: 0;
            font-size: 14px;
            line-height: 24px;
            color: #828596;
          }
        }
      }
    }

    .settlement-rights-box {
      padding: 116px 16px 0;
      overflow: hidden;

      &.settlement-rights-box0 {
        min-height: 1163px;
        padding-top: var(--settlement-right1-pt);
        background-image: url("~/assets/images/aigc/bg-2.png");
      }

      &.settlement-rights-box1 {
        min-height: 1080px;
        background-image: url("~/assets/images/aigc/bg-1.png");
      }

      &.settlement-rights-box2 {
        min-height: 1074px;
        background-image: url("~/assets/images/aigc/bg-2.png");
      }

      &.settlement-rights-box3 {
        min-height: 1448px;
        background-image: url("~/assets/images/aigc/bg-1.png");
      }

      :deep(.carousel-component) {
        box-shadow: 0 18px 45px rgba(216, 224, 241, 39%);

        .ant-carousel {
          box-shadow: none;
        }
      }

      .ant-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 65.83vw;
        min-width: 288px;
        height: 97px;
        margin: var(--settlement-btn-m);
        font-size: var(--settlement-btn-text);
        font-weight: bold;
        line-height: var(--settlement-btn-leading);
        color: #7d4242;
        background: linear-gradient(90deg, #ffc063 0%, #ffedd4 50%, #ffc063 100%);
        border: none !important;
        border-radius: 98px;
        box-shadow:
          inset 0 2px 2px white,
          inset 0 -2px 2px rgba(91, 42, 31, 35%);
      }
    }

    :deep(.carousel-component-image) {
      padding: 40px 52px !important;
      background: linear-gradient(180deg, rgba(87, 144, 255, 59%) 24%, rgba(255, 255, 255, 69%) 100%) !important;

      img {
        padding: 14px 16px !important;
        background-color: white;
      }
    }
  }
</style>
